import {
  broadcastMsalAuthResponse,
  isMsalAuthResponse,
} from "./auth/msalRedirectBridge";
import { captureAndScrubN8nResourceTicket } from "./lib/beta/n8nResourceTicket";
import { captureAndScrubMarketplacePurchaseToken } from "./lib/marketplacePurchaseToken";

async function bootstrap(): Promise<void> {
  if (isMsalAuthResponse(window.location)) {
    // MSAL Browser v5 requires the redirect bridge to own the callback page.
    // Do not mount React, the router, analytics, or AuthProvider here: any of
    // them can alter the auth fragment before the popup opener receives it.
    await broadcastMsalAuthResponse();
    return;
  }

  // Capture and scrub the opaque bearers before importing the app graph. That
  // graph imports Sentry and PostHog; doing this before the dynamic import
  // prevents either SDK from observing the original query even at module load.
  captureAndScrubN8nResourceTicket();
  // PKG-MKT-TRANSACT-SEC-LANDING (SEC-MKT-01) — the Marketplace purchase token
  // is a 24 h bearer against an unauthenticated resolve endpoint. Scoped to the
  // activation landing so `/team/join?token=` keeps its own query.
  captureAndScrubMarketplacePurchaseToken();

  await import("./appBootstrap");
}

void bootstrap().catch((error: unknown) => {
  console.error("[auth] application bootstrap failed", error);
});
